/* eslint-disable react/no-array-index-key */
import { Common } from '@stockbit/ui';
import { useEffect, useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { MyWatchlistResult, MyWatchlistWrapper, SkeletonItemCheckbox, SkeletonItemText } from './styled';
import { watchlistListStore } from './store';
import { Watchlist } from '../../../../../../../../@types/watchlist';
import { Checkbox } from '../../styled';
import { RunningTradeStockFilter, StockFilterTypeEnum } from '../../../types';

const { Text, Flex } = Common;

interface WatchlistItemProps extends Watchlist {
  onClick: (watchlist: Watchlist) => void;
  isChecked: boolean;
}

const WatchlistItem = (props: WatchlistItemProps) => {
  const {
    name,
    total_items: totalItems,
    onClick,
    isChecked,
  } = props;

  return (
    <Flex
      py="10px"
      justify="space-between"
      align="center"
      className="item"
      onClick={() => onClick(props)}
    >
      <Text size="13px" ellipsis width="140px">
        {name}
      </Text>
      <Flex
        align="center"
        style={{ gap: 32 }}
      >
        <Text
          size="13px"
          color="#858585"
        >
          {totalItems} Stocks
        </Text>
        <Checkbox
          checked={isChecked}
        />
      </Flex>
    </Flex>
  );
};

interface IMyWatchlist {
  filter: RunningTradeStockFilter;
  setFilter: (value: RunningTradeStockFilter) => void;
}

const MyWatchlist = ({
  filter,
  setFilter,
}: IMyWatchlist) => {
  const [page, setPage] = useState(1);

  const isLoading = watchlistListStore((s) => s.isLoading);
  const data = watchlistListStore((s) => s.data);
  const hasNext = watchlistListStore((s) => s.hasNext);
  const fetchWatchlist = watchlistListStore((s) => s.fetch);

  useEffect(() => {
    fetchWatchlist(page);
  }, [page]);

  const handleLoadMore = (isVisible: boolean) => {
     if (isVisible && !isLoading && hasNext) {
      setPage((prev) => prev + 1);
     }
  };

  const handleSelectWatchlist = (watchlist: Watchlist) => {
    setFilter({
      type: StockFilterTypeEnum.Watchlist,
      watchlistId: watchlist.watchlist_id,
      watchlistName: watchlist.name,
      watchlistItemCounts: watchlist.total_items,
    });
  };

  return (
    <MyWatchlistWrapper>
      <MyWatchlistResult>
        <Text weight="700" mb="8px">
          From My Watchlist
        </Text>
        {data.map((item) => (
          <WatchlistItem
            {...item}
            key={item.watchlist_id}
            onClick={handleSelectWatchlist}
            isChecked={
              filter?.type === StockFilterTypeEnum.Watchlist &&
              filter?.watchlistId === item.watchlist_id
            }
          />
        ))}
        {isLoading && (
          <>
            {[...Array(4)].map((___, i) => (
              <Flex
                align="center"
                justify="space-between"
                py="10px"
                key={i}
              >
                <SkeletonItemText width="70px" />
                <Flex align="center" style={{ gap: 8 }}>
                  <SkeletonItemText width="70px" />
                  <SkeletonItemCheckbox>
                    <div className="checkbox" />
                  </SkeletonItemCheckbox>
                </Flex>
              </Flex>
            ))}
          </>
        )}
        {!isLoading && (
          <VisibilitySensor onChange={handleLoadMore}>
            <div>&nbsp;</div>
          </VisibilitySensor>
        )}
      </MyWatchlistResult>
    </MyWatchlistWrapper>
  );
};

export default MyWatchlist;
